import { flushPendingScore } from "./sessionScore";
import { clearActivity } from "./idleLogout";
import { __resetModuleVisibilityCache } from "./homeModuleVisibility";
import { apiFetch } from "../../api/apiFetch";
import { clearSessionToken, getSessionToken } from "../../api/apiFetch";
import { clearAuthFlags } from "./authFlags";

export const logoutProcessor = async () => {
    const userData = window.localStorage.getItem("user");
    const userObject = userData !== null ? JSON.parse(userData) : { uid: 0, name: "", permissions: "" };

    await flushPendingScore().catch(() => {});

    // POST /login/logout so the BE destroys the session, releases the
    // single-session claim, pauses the picker's active wave and the
    // auto-logging middleware records a Logout row. Until 2026-09-21
    // this posted to /logout, which no router claims — the API's tail
    // answered 200 "JLI API" and the server session lived on until it
    // expired (and every next login "evicted" it). The identity in the
    // body is a fallback for the audit row only.
    // Bearer header is included inline (rather than via apiFetch) so
    // this stays a single dependency-free fetch — keepalive must work
    // even if the bundle is mid-teardown on tab close.
    // Fire-and-forget: a network failure must not block a logout.
    try {
        const token = getSessionToken();
        const headers: Record<string, string> = { "Content-Type": "application/json" };
        if (token) headers["Authorization"] = `Bearer ${token}`;
        await apiFetch(`/login/logout`, {
            method: "POST",
            headers,
            body: JSON.stringify({
                uid: userObject.uid,
                name: userObject.name,
                warehouse: userObject.warehouse,
            }),
            keepalive: true,
        });
    } catch { /* swallow — logout must always succeed locally */ }

    clearSessionToken();
    // The next sign-in must re-read module visibility rather than inherit
    // this session's cached map — there's no page reload between logins.
    __resetModuleVisibilityCache();
    window.localStorage.removeItem("user");
    window.localStorage.setItem("isLoggedIn", "false");
    // A session that died mid account-setup / rotation must not trap the
    // next person to sign in on this device — the BE re-sends the flags.
    clearAuthFlags();
    // AccessContext listens for this (same-tab; `storage` only fires in
    // OTHER tabs) so it drops its cached /access-control/my pages instead
    // of leaving the next signed-out route guard deciding on stale grants.
    window.dispatchEvent(new Event("portal:logout"));
    clearActivity();
    // Drop the scansheet location lock so the next login has to re-scan
    // a location barcode rather than inheriting the previous operator's.
    window.sessionStorage.removeItem("scansheet_active_location");

    return;
}